import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const IMG = "https://images.unsplash.com/photo-1626383137804-ff908d2753a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      navigate("/onboarding");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAF8F5]">
      <div className="flex items-center justify-center p-6 sm:p-10 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-sm animate-fade-up">
          <h1 className="font-extrabold text-3xl">Start your free trial</h1>
          <p className="mt-2 text-stone-600 text-sm">14 days free · £19.99/month after · no card needed.</p>
          {error && <div data-testid="register-error" className="mt-4 text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-lg px-3 py-2">{error}</div>}
          <div className="mt-6 space-y-4">
            <div>
              <Label htmlFor="name">Your name</Label>
              <Input id="name" data-testid="register-name-input" value={form.name} onChange={set("name")} required className="mt-1.5 h-11 rounded-lg" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="register-email-input" value={form.email} onChange={set("email")} required className="mt-1.5 h-11 rounded-lg" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" data-testid="register-password-input" value={form.password} onChange={set("password")} required minLength={6} className="mt-1.5 h-11 rounded-lg" />
            </div>
          </div>
          <Button type="submit" data-testid="register-submit-button" disabled={loading}
            className="mt-6 w-full h-11 rounded-full bg-stone-900 hover:bg-stone-800">
            {loading ? "Creating account…" : "Create account"}
          </Button>
          <p className="mt-5 text-sm text-center text-stone-600">
            Already have an account? <Link to="/login" className="font-semibold text-stone-900 underline">Sign in</Link>
          </p>
        </form>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src={IMG} alt="Stylist at work" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-stone-900/25" />
      </div>
    </div>
  );
}
